import React, { ReactNode, ReactText, useEffect } from 'react';
import { Trans } from '@lingui/react/macro';
import { getProjectFeeSets } from '@/services/fees';
import { useAsyncState } from '@/utils/hooks';
import { NoAvailableFeesAlert } from '@/seller/components/fees';
import { useLingui } from '@lingui/react/macro';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';

export interface LinkToUnitPriceFeeSetProps {
    selectedProjectId: number | null;
    onChange: (id: number | null) => void;
    value: number | null;
}
export const LinkToUnitPriceFeeSet: React.FC<LinkToUnitPriceFeeSetProps> = ({ selectedProjectId, onChange, value }) => {
    const { t } = useLingui();
    const [projectFeeSets] = useAsyncState(
        () => (selectedProjectId ? getProjectFeeSets(selectedProjectId) : Promise.resolve([])),
        [selectedProjectId],
        null
    );

    useEffect(() => {
        if (projectFeeSets && projectFeeSets.length >= 1 && value === null) {
            onChange(projectFeeSets[0].id);
        }
    }, [projectFeeSets, value, onChange]);

    if (!projectFeeSets) {
        return (
            <Select onChange={(nv: any) => onChange(nv.value)} options={[{ label: <Trans>Loading</Trans>, value: '' }]} />
        );
    }

    const options: { label: ReactNode; value: ReactText; isDefault: boolean }[] = projectFeeSets.map((pf) => ({
        label: pf.name,
        value: pf.id,
        isDefault: pf.isDefault,
    }));

    if (projectFeeSets.length === 0) {
        return <NoAvailableFeesAlert />;
    }

    return (
        <Select
            fieldName={t`Fee preset`}
            required
            // defaultValue={options[0]} // options.find((o) => o.isDefault) Todo, implement this thing
            onChange={(nv: any) => onChange(nv.value)}
            value={options.find((f) => f.value === value)}
            options={options}
        />
    );
};
